import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors } from "style";
import MissionIcon from "assets/images/MissionIconBlack.svg";
import MissionGradient from "assets/images/gradient_medium.webp";

/**
 * MarketingLogo
 *
 * @param {String}   icon              URL of the mark used as the mask
 * @param {String}   hoverBackground   CSS background-image revealed on hover
 * @param {String}   width             CSS length
 */
const MarketingLogo = ({
  icon = MissionIcon,
  hoverBackground = `url(${MissionGradient})`,
  width = "4.8rem",
  ...props
}) => <div css={styles.logo(icon, hoverBackground, width)} {...props} />;

const styles = {
  logo: (icon, hoverBackground, width) => css`
    flex-shrink: 0;
    height: 2.2rem;
    mask-image: url(${icon});
    overflow: hidden;
    position: relative;
    width: ${width};

    &:hover:after {
      opacity: 1;
    }

    &:before,
    &:after {
      bottom: 1px;
      content: "";
      left: 1px;
      position: absolute;
      right: 1px;
      top: 1px;
    }

    &:before {
      background-color: ${colors.black};
    }

    &:after {
      background-image: ${hoverBackground};
      background-size: cover;
      opacity: 0;
      transition-duration: 0.3s;
      transition-property: opacity;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    }
  `,
};

MarketingLogo.propTypes = {
  icon: PropTypes.string,
  hoverBackground: PropTypes.string,
  width: PropTypes.string,
};

export default MarketingLogo;
